export const USER = {
  firstName: "Tarek",
  lastName: "Hammami",
  displayName: "Tarek Hammami",
  username: "tarekhammami",
  gender: "male",
  bio: "Creating with code, driven by passion.",
  flipSentences: [
    "AI-First Software Engineer",
    "Full Stack Developer",
    "IT Automation Specialist",
    "Open Source Contributor",
    "Focused on performance, UX and scalability.",
    "Transforming ideas into functional web products.",
    "Passionate about technology and impact.",
    "Developing agile, clean and maintainable solutions.",
    "#OpenToOpportunities #GlobalCollaborations #PositiveImpact",
  ],
  address: "Berlin, Germany",
  phoneNumber: "", // E.164 format, base64 encoded (https://t.io.vn/base64-string-converter)
  email: "Y29udGFjdEB0YXJla2hhbW1hbWkuY29t", // base64 encoded
  website: "https://tarekhammami.com",
  otherWebsites: [],
  jobTitle: "Software Developer",
  jobs: [
    {
      title: "Software Developer",
      company: "",
      website: "",
    },
    // {
    //   title: "Founder",
    //   company: "",
    //   website: "",
    // },
  ],
  //   about: `
  // Hello, World! I am Tarek Hammami — a Software Developer & UI/UX Designer passionate about creating high-performance, user-centric software solutions with intuitive and engaging designs.

  // With 5+ years of experience, I specialize in building high-quality web and mobile applications using Next.js, React, TypeScript, and modern front-end technologies. Beyond work, I love exploring new technologies and turning ideas into reality through personal projects.

  // One of my key projects, [ZaDark](https://zadark.com), enhances the Zalo experience on PC and Web, surpassing 80,000 downloads on [SourceForge](https://sourceforge.net/projects/zadark) and 15,000 active users on the [Chrome Web Store](https://chromewebstore.google.com/detail/llfhpkkeljlgnjgkholeppfnepmjppob) since 2022.

  // Let's connect and collaborate!
  //   `,
  // about: `
  // Hello, World! I am Tarek Hammami — a Software Developer passionate about creating high-performance, user-centric software solutions with intuitive and engaging designs.

  // With 5+ years of experience, I specialize in building high-quality web and mobile applications using Next.js, React, Node.js and TypeScript, and modern web technologies. Beyond work, I love exploring new technologies and turning ideas into reality through personal projects.

  // Let's connect and collaborate!
  //   `,
  about: `
  Hello, World! I am **_Tarek Hammami_** — a **Software Developer** with extensive experience in international environments.
  
  \\>_ **👨‍💻 Expert Frontend / Backend / Full Stack Developer**
  
  \\>_ **🚀 30+ Full Stack Projects Completed**

  \\>_ **🌎 Available Globally:** US, Canada, Europe, or any preferred time zone

  \\>_ **🗣️ Languages I Speak:** English, French, and Arabic + currently learning German

  \\>_ **🌟 Notable companies & organizations:**

  - _DevNet_ in collaboration with _MongoDB Inc._ (world's leading NoSQL database company)
  - _MyUnisoft_ (ranked 185th among France's top software editors) at _Cegid Data Lab_, _Station F_ (world's largest startup campus in Paris)
  - _Central Bank of Morocco_ via _Berexia Digital_
  - _Microverse_ (a San Francisco-based company)
  - _JPME_ (one of France's electricity providers)
  - _Enactus_ (one of the largest global organizations for social entrepreneurship)

  \\>_ **🏆 A few of my achievements:**
  - Earned Top Rated Plus status on Upwork and Active Developer within the Discord developer community
  - Contributed to private codebases of internal tools and platforms powering products used by countless users daily
  - Hold recognized certifications from Google Cloud, AWS, MongoDB, and more
  - Built open source tools with 10k+ downloads across the Chrome Web Store and Visual Studio Marketplace
  - Earned 80+ stars and made 4.5k+ contributions on GitHub
  - Gained 1.2k+ reputation and wrote technical content read by 100k+ developers on Stack Overflow

  \\>_ **💡 Fields of expertise:**
  - Full Stack Development
  - Scripting & IT Automation
  - Custom Tool Creation (CLI tools, Chrome extensions, plugins, etc.)
  - AI Integration
  - DevOps
  - SaaS & Startups

  \\>_ **🔬 My experience spans a range of sectors, including:**
  - 💻 Fintech
  - 📊 AI, B2B Solutions & Data Visualization
  - 🔓 Open-Source
  - 🔗 Blockchain & Web3 dApps
  - 📱 E-commerce & Online Booking
  - 🏭 Industrial Optimization & Operations
  - 🏥 MedTech
  - 📈 EdTech
  - ♻️ Sustainability & Green Tech

  \\>_ **💬 _Let's talk about your ideas and transform them into reality!_**
    `,
  avatar:
    "https://res.cloudinary.com/dgihbgsnz/image/upload/v1754251844/personal-website-v4/profile-pic_wwirm6.png",
  avatarWebp:
    "https://res.cloudinary.com/dgihbgsnz/image/upload/v1754251844/personal-website-v4/profile-pic_wwirm6.png",
  ogImage:
    "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753053822/personal-website-v4/welcome_xsdezj.png",
  keywords:
    "thammami, tarekhammami, tarek hammami, tarekh, th01, th, thammami01, tarekhammamix01",
  dateCreated: "2025-07-18", // YYYY-MM-DD
};
